import clsx from "clsx";

interface Props {
    className?: string
    FillColor?: string
}

export default function YouTube({className, FillColor = 'black'}:Props) {
    return (
        <svg width="24" height="24" className={clsx(className, FillColor)}>
            <path fillRule="evenodd" clipRule="evenodd" d="M19.814 5.83c.86.231 1.538.913 1.768 1.78C22 9.18 22 12.455 22 12.455s0 3.275-.418 4.845a2.513 2.513 0 0 1-1.768 1.78c-1.56.42-7.814.42-7.814.42s-6.254 0-7.814-.42a2.513 2.513 0 0 1-1.768-1.78C2 15.73 2 12.455 2 12.455s0-3.276.418-4.846a2.513 2.513 0 0 1 1.768-1.78C5.746 5.41 12 5.41 12 5.41s6.254 0 7.814.42zm-4.632 6.625-5.227 2.973V9.481l5.227 2.974z"/>
        </svg>
    )
}
